import { ICategoryTag } from "types";

export const calculateTotal = (
  categories: ICategoryTag[],
  selected: string[]
) => {
  const data: string[] = [];

  for (const category of categories) {
    const { name, tags } = category;
    const mapped = tags.map((tag) => tag.name);

    let count = 0;

    selected.forEach((item) => {
      if (mapped.includes(item)) {
        count += 1;
      }
    });

    if (count > 0) {
      data.push(`${name.toUpperCase()}-${count}`);
    }
  }

  return data.join(" | ");
};
